import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class WaitingListTicketModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, eventId, waitingListId }) {
        if (!organizationId || !eventId || !waitingListId) {
            throw new ArgumentError(`[Model][WaitingListTicketModel] organizationId, eventId and waitingListId are mandatory`);
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/waiting_lists/${waitingListId}/waiting_lists_tickets`;
    }

    static perform_cancel_subscription(waitingListTicket, organizationId, eventId, waitingListId, async = false) {
        const waitingListTicketIds = waitingListTicket.map(element => element.id);
        if (!async) {
            return fetcher.post(`/ticket/organizations/${organizationId}/events/${eventId}/waiting_lists/${waitingListId}/waiting_lists_tickets/cancel_subscription`, {
                data: { id: waitingListTicketIds[0] }
            });
        }
        return fetcher.post(`/ticket/organizations/${organizationId}/events/${eventId}/waiting_lists/${waitingListId}/waiting_lists_tickets/actions`, {
            data: {
                type: 'async_cancel_subscription',
                resource_query_filter: {
                    id__in: waitingListTicketIds.join(',')
                },
                config: {}
            }
        });
    }
}
